import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  portrait: {},
  landscape: {},
  videoControlled: {},
  isFullscreen: {},
  noContent: {},
  hideEngagements: {},
  donateMode: {},
  popoutMode: {},
  actions: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',
    '&$portrait': {
      '@media (max-width: 767px)': {
        '&:not($isFullscreen)': {
          display: 'none'
        },
        '&$actionsMobile': {
          display: 'flex',
          transition: theme.transitions.create('height', {
            duration: theme.transitions.duration.standard,
            easing: theme.transitions.easing.easeInOut
          })
        }
      },
      '&$videoControlled': {
        '@media (max-width: 767px)': {
          '&$actionsMobile:not($noContent)': {
            height: 240
          },
          '&$hideEngagements&$donateMode:not($noContent)': {
            position: 'absolute',
            bottom: 0
          }
        }
      }
    },
    '&$popoutMode': {
      display: 'none'
    }
  },
  actionsMobile: {
    overflow: 'hidden',
    position: 'relative',
    display: 'none',
    height: 0,
    flexDirection: 'column',
    backgroundColor: '#333333'
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/EngagementButtons/styles.js